export default "__VITE_ASSET__B9ytb8Bp__"